import { CancelToken } from 'axios'

import { DataReport } from 'Core/common/DataReport/types'
import { TableUrlParams } from 'Core/interfaces'
import { Http } from 'Core/utils'

import { Report } from 'Portals/Supplier/entities'

import { baseUrl } from './constants'

export const searchSuggestions = (
	params: TableUrlParams,
	cancelToken?: CancelToken
): Promise<string[]> => Http.get(`${baseUrl}/search-suggestions`, { params, cancelToken })

export const getList = (
	params: TableUrlParams
): Promise<{ items: Report.Basic[]; total: number }> => Http.get(`${baseUrl}/logs`, { params })

export const downloadReport = (reportId: Key): Promise<Blob> =>
	Http.get(`${baseUrl}/${reportId}/download`, {
		responseType: 'blob'
	})

export const retrieveReportNameOptions = (): Promise<Entity[]> =>
	Http.get(`${baseUrl}/report-names/options`)

export const generateReport = (id: Key, data: DataReport.Request): Promise<void> =>
	Http.post(`${baseUrl}/${id}/generate`, {
		...data,
		$type: 1
	})

export const retrieveReportData = (id: number): Promise<DataReport.Detailed> =>
	Http.get(`${baseUrl}/${id}`)

export const generateEmailReport = (id: Key, data: DataReport.Request): Promise<void | string> =>
	Http.post(`${baseUrl}/${id}/send-to-email`, {
		...data,
		$type: 1
	})

export const retrievePreviewOptions = (
	parameterId: Key,
	query?: string
): Promise<ValueDescription[]> =>
	Http.get(`parameters/${parameterId}/values`, { params: { query } })
